import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-8 flex items-start justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-700 text-3xl font-semibold mb-1" }, "Manage Students"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600" }, "Manage Student logins and settings.")
], -1)
const _hoisted_3 = { class: "flex gap-2 items-center justify-end [&>button]:py-2 [&>button]:px-3 [&>button]:flex [&>button]:flex-row [&>button]:justify-center [&>button]:items-center [&>button]:rounded-lg [&>button]:text-semibold [&>button]:border [&>button]:gap-1" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "flex items-center",
  role: "status"
}
const _hoisted_6 = { class: "[&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_7 = { class: "border-gray-300" }
const _hoisted_8 = { class: "[&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "flex items-center",
  role: "status"
}
const _hoisted_11 = { class: "mb-8 flex flex-wrap items-center gap-4" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-wrap items-center gap-4"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "grade-filter",
  class: "text-gray-800 text-sm font-semibold"
}, "Class(es) / Grade(s)", -1)
const _hoisted_14 = { class: "min-w-[18rem]" }
const _hoisted_15 = { class: "ml-auto" }
const _hoisted_16 = {
  key: 0,
  class: "bg-white rounded-lg border border-gray-300 p-12 text-center"
}
const _hoisted_17 = { class: "flex flex-col items-center justify-center" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-gray-500" }, "Loading students...", -1)
const _hoisted_19 = {
  key: 1,
  class: "bg-white rounded-lg border border-gray-300 p-12 text-center"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold text-gray-900 mb-2" }, " We couldn't determine your school. ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600 mb-4" }, " Please reload your students or log out and back in to refresh your session. ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600 mb-4" }, " If the issue persists, contact Support for assistance. ", -1)
const _hoisted_23 = {
  key: 2,
  class: "bg-white rounded-lg border border-gray-300 overflow-hidden"
}
const _hoisted_24 = { class: "overflow-x-auto" }
const _hoisted_25 = { class: "min-w-full divide-y divide-gray-300" }
const _hoisted_26 = { class: "bg-gray-50" }
const _hoisted_27 = { class: "flex items-center space-x-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "Student Name", -1)
const _hoisted_29 = { class: "flex items-center space-x-1" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "Username/Email", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("th", { class: "w-48 px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider" }, " Password ", -1)
const _hoisted_32 = { class: "flex items-center space-x-1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "Maths Class", -1)
const _hoisted_34 = { class: "flex items-center space-x-1" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "English Class", -1)
const _hoisted_36 = { class: "flex items-center space-x-1" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "Class", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-right text-xs font-medium text-gray-500 tracking-wider" }, null, -1)
const _hoisted_39 = { class: "bg-white divide-y divide-gray-300" }
const _hoisted_40 = { class: "px-6 py-6 whitespace-nowrap" }
const _hoisted_41 = {
  key: 0,
  class: "text-sm font-medium text-gray-900 truncate max-w-[12rem] cursor-default select-text"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "relative px-6 py-6 whitespace-nowrap" }
const _hoisted_44 = {
  style: {"position":"absolute"},
  class: "cursor-pointer inset-5"
}
const _hoisted_45 = { class: "text-sm text-gray-600 cursor-pointer truncate max-w-[12rem]" }
const _hoisted_46 = { class: "px-6 py-6 whitespace-nowrap" }
const _hoisted_47 = { class: "flex items-center space-x-2" }
const _hoisted_48 = { class: "text-sm text-gray-600" }
const _hoisted_49 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_50 = { key: 1 }
const _hoisted_51 = ["onClick", "disabled"]
const _hoisted_52 = {
  key: 0,
  class: "animate-spin h-4 w-4 text-gray-400",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = {
  key: 0,
  class: "px-6 py-6 whitespace-nowrap"
}
const _hoisted_57 = { class: "text-sm text-gray-600" }
const _hoisted_58 = {
  key: 1,
  class: "px-6 py-6 whitespace-nowrap"
}
const _hoisted_59 = { class: "text-sm text-gray-600" }
const _hoisted_60 = {
  key: 2,
  class: "px-6 py-6 whitespace-nowrap"
}
const _hoisted_61 = { class: "text-sm text-gray-600" }
const _hoisted_62 = { class: "px-6 py-6 whitespace-nowrap text-right text-sm font-medium" }
const _hoisted_63 = { class: "flex justify-end space-x-3" }
const _hoisted_64 = ["onClick"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = {
  key: 3,
  class: "text-center py-12"
}
const _hoisted_68 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_69 = { class: "mb-4" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold text-gray-900 mb-2" }, "No Students found", -1)
const _hoisted_71 = { class: "text-sm text-gray-600 mb-1" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, " Students in the Class(es) / Grade(s) selected. ", -1)
const _hoisted_73 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_74 = { class: "mb-4" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-semibold text-gray-900 mb-2" }, "No Students found", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, " There are currently no Students in the ", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, " Class(es) / Grade(s) selected. ", -1)
const _hoisted_78 = {
  key: 4,
  class: "mt-6 flex items-center justify-between text-sm text-gray-500"
}
const _hoisted_79 = {
  key: 5,
  class: "mt-6 flex items-center justify-between text-sm text-gray-500"
}
const _hoisted_80 = { class: "p-6 text-center" }
const _hoisted_81 = { class: "flex justify-center items-center mb-4" }
const _hoisted_82 = { class: "text-lg font-semibold text-primary mb-1" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("p", { class: "text-tertiary mb-8 text-sm" }, " Are you sure you want to archive this user? ", -1)
const _hoisted_84 = { class: "flex flex-col gap-2" }
const _hoisted_85 = ["disabled"]
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", null, "Archive", -1)
const _hoisted_87 = {
  key: 0,
  class: "relative ml-2 flex items-center"
}
const _hoisted_88 = { class: "p-8 text-center" }
const _hoisted_89 = { class: "flex justify-center items-center mb-4" }
const _hoisted_90 = { class: "text-lg font-semibold text-primary mb-4" }
const _hoisted_91 = {
  key: 0,
  class: "mb-6 text-tertiary text-sm"
}
const _hoisted_92 = { class: "font-medium font-semibold" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_95 = {
  key: 1,
  class: "mb-6 text-tertiary text-sm"
}
const _hoisted_96 = { class: "font-medium font-semibold" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_99 = { class: "flex w-full justify-center mt-8 border-t border-[#EAECF0] pt-8" }
const _hoisted_100 = {
  key: 0,
  class: "inline-block me-2",
  role: "status"
}
const _hoisted_101 = { class: "p-8 text-center" }
const _hoisted_102 = { class: "flex justify-center items-center mb-4" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold text-primary mb-4" }, "Trigger Reassessment", -1)
const _hoisted_104 = { class: "mb-6 text-tertiary text-sm" }
const _hoisted_105 = { class: "font-semibold" }
const _hoisted_106 = { key: 0 }
const _hoisted_107 = { class: "font-semibold" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_110 = { class: "flex w-full justify-center mt-8 border-t border-[#EAECF0] pt-8" }
const _hoisted_111 = ["disabled"]
const _hoisted_112 = {
  key: 0,
  class: "inline-block me-2",
  role: "status"
}
const _hoisted_113 = { class: "p-6 text-center" }
const _hoisted_114 = { class: "text-xl font-semibold text-gray-900 mb-8" }
const _hoisted_115 = { class: "text-gray-600 mb-8" }
const _hoisted_116 = { class: "w-screen max-w-5xl" }
const _hoisted_117 = { class: "relative" }
const _hoisted_118 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_119 = { class: "flex flex-col items-center px-4 py-6" }
const _hoisted_120 = { class: "mt-6 font-semibold text-2xl text-gray-900" }
const _hoisted_121 = ["innerHTML"]
const _hoisted_122 = { class: "font-normal text-sm text-red-600 text-center mt-5" }

import {
  ref,
  watch,
  inject,
  computed, 
  onMounted} from 'vue';

import { useRoute } from 'vue-router';

import {
  EyeIcon,
  UserIcon,
  PlusIcon,
  EyeSlashIcon,
  ArrowPathIcon,
  CheckCircleIcon,
  ChevronRightIcon,
  ChevronUpDownIcon,
  MagnifyingGlassIcon,
  ExclamationCircleIcon
} from '@heroicons/vue/24/outline';

import { useSchoolStore } from '@/stores/schoolStore';
import { useSubjectStore } from '@/stores/subjectStore';
import { useLearnerStore } from '@/stores/learnerStore';
import { useUserStore } from '@/stores/userStore';
import { useFilterStore } from '@/stores/filterStore';
import { useActivityLogStore } from '@/stores/activityLogStore';
import { useGradeSubjectFilterOptions } from '@/composables/useGradeSubjectFilterOptions';

import { Learner } from '@/interfaces/learner.interface';
import { showToast } from '@/utils/toastUtils';
import { generatePdf } from '@/utils/print-passwords.js';
import { logger } from '@/utils/logger';
import { getLearnerAppUrl } from '@/lib/runtime-url-resolver';

import AddLearnerModalComponent from '../components/manage/AddLearnerModalComponent.vue';
import EditLearnerModalComponent from '../components/manage/EditLearnerModalComponent.vue';
import router from '@/router';
import ExportLearnersButtonComponent from '../components/manage/ExportLearnersButtonComponent.vue';

import BulkUploadLearners from "../components/BulkLearnersUploadComponent.vue";
import PreviewBulkUploadComponent from "../components/PreviewBulkUploadComponent.vue";

interface StudentDisplay extends Learner {
  showPassword: boolean;
  password: string;
  displayName: string;
  mathClasses: string[];
  englishClasses: string[];
}

const BATCH_SIZE = 50;

// reactive state

export default /*#__PURE__*/_defineComponent({
  __name: 'StudentViewNew',
  setup(__props) {

const bus = inject("bus") as { emit: (event: string, payload: any) => void };

const showBulkAddButton = process.env.VUE_APP_BULK_ADD_BUTTON === "true";

const route = useRoute();

const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();
const learnerStore = useLearnerStore();
const userStore = useUserStore();
const filterStore = useFilterStore();
const activityLogStore = useActivityLogStore();

// constants
const showAddLearnerModal = ref(false);
const showEditLearnerModal = ref(false);
const showArchiveLearnerModal = ref(false);
const selectedLearner = ref<Learner | null>(null);

const searchQuery = ref<string>('');
const gradeFilter = ref<string>('');
const itemsPerPage = ref<number>(BATCH_SIZE);

const pageLoading = ref<boolean>(true);
const loadError = ref<boolean>(false);

/**
 * Resolve a valid schoolId without trusting a possibly-empty cache.
 */
function resolveSchoolId(): string | undefined {
  if (filterStore.selectedSchool?._id) return filterStore.selectedSchool._id;
  if (schoolStore.currentSchoolStructure?._id) return schoolStore.currentSchoolStructure._id;
  const firstGroup = filterStore.filterOptions?.schoolGroups?.find(
    (sg) => (sg.schools?.length ?? 0) > 0
  );
  return firstGroup?.schools?.[0]?._id;
}

/**
 * Always load fresh school structure + learners for the resolved school so the
 * page never depends on whatever happens to be persisted in this browser.
 */
async function loadStudents() {
  loadError.value = false;
  pageLoading.value = true;
  try {
    const schoolId = resolveSchoolId();
    if (!schoolId) {
      loadError.value = true;
      logger.error('students.school_unresolvable', {
        userEmail: userStore.user?.email ?? null,
        userFullName: [userStore.user?.firstName, userStore.user?.lastName].filter(Boolean).join(' ') || null,
        schoolName: filterStore.selectedSchool?.name ?? schoolStore.currentSchoolStructure?.name ?? null,
        schoolGroup: filterStore.selectedSchoolGroup?.name ?? null,
        filterGroupCount: filterStore.filterOptions?.schoolGroups?.length ?? 0,
      });
      return;
    }

    if (schoolStore.currentSchoolStructure?._id !== schoolId) {
      await schoolStore.fetchSchoolStructure(schoolId);
    }
    await learnerStore.fetchSchoolLearners(schoolId);
  } catch (error) {
    // Without a catch a thrown fetch left loadError false and the user saw an
    // empty table instead of the error/retry UI. Surface the failure instead.
    loadError.value = true;
    logger.error('students.load_failed', {
      error: error instanceof Error ? error.message : String(error),
      userEmail: userStore.user?.email ?? null,
    });
  } finally {
    pageLoading.value = false;
  }
}

const sortField = ref<string>('name');
const sortDirection = ref<'asc' | 'desc'>('asc');

// passwords view management
const decryptedPasswords = ref<Record<string, string>>({});
const decryptionLoading = ref<Record<string, boolean>>({});
const passwordVisibility = ref<Record<string, boolean>>({});

//print logins
const showConfirmDownloadModal = ref(false);
const loading = ref(false);
const downloadType = ref<'single' | 'all'>('single');

// reassessment
const showReassessmentConfirmModal = ref(false);
const reassessmentLoading = ref(false);


// Watch for filter changes and reset pagination
watch([searchQuery, gradeFilter], () => {
  itemsPerPage.value = BATCH_SIZE; // Reset to initial page size when filters change
});

const pages = [{
  name: 'Manage Students',
  path: '/studentsnew'
}];

/**
 * Computed properties
 */
const totalStudents = computed(() => learnerStore.schoolLearners?.length || 0);

const isV2Only = computed(() => schoolStore.lingoMode === 'v2');

const displayStudents = computed((): StudentDisplay[] => {
  return (learnerStore.schoolLearners || [])
    .filter(learner => learner.status === 'active')
    .map(learner => {
      const mathClasses = learner.classes
        ?.filter(cls => cls.subject.code === 'MATHS')
        .map(cls => cls.name) || [];
      
      const englishClasses = learner.classes
        ?.filter(cls => cls.subject.code === 'ENGLISH')
        .map(cls => cls.name) || [];

      // keep ids too so filters can match on unique id
      const mathClassIds = learner.classes
        ?.filter(cls => cls.subject.code === 'MATHS')
        .map(cls => cls._id) || [];
      const englishClassIds = learner.classes
        ?.filter(cls => cls.subject.code === 'ENGLISH')
        .map(cls => cls._id) || [];

      return {
        ...learner,
        password: decryptedPasswords.value[learner._id] || '',
        showPassword: passwordVisibility.value[learner._id] || false,
        displayName: `${learner.lastName}, ${learner.firstName}`,
        mathClasses,
        englishClasses,
        mathClassIds,
        englishClassIds
      };
    });
});

const isSearchEmpty = computed(() => {
  return searchQuery.value.trim().length > 0 && filteredStudents.value.length === 0;
});

const filteredStudents = computed(() => {
  let filtered = displayStudents.value;

  // Apply search filter
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase();
    filtered = filtered.filter(student => 
      (student.displayName && student.displayName.toLowerCase().includes(query)) ||
      (student.email && student.email.toLowerCase().includes(query)) ||
      (student.firstName && student.firstName.toLowerCase().includes(query)) ||
      (student.lastName && student.lastName.toLowerCase().includes(query))
    );
  }

  // Apply grade/class filter
  if (gradeFilter.value) {
    if (gradeFilter.value.startsWith('grade-')) {
      const match = gradeFilter.value.match(/^grade-(\d+)(?:-(\w+))?$/);
      const gradeLevel = match ? parseInt(match[1]) : null;
      const subjectCode = match ? match[2] : null;

      if (!gradeLevel) {
        // invalid grade filter; keep current list
      } else if (subjectCode) {
        const classIds =
          subjectCode === 'MATHS'
            ? (student: any) => student.mathClassIds || []
            : subjectCode === 'ENGLISH'
              ? (student: any) => student.englishClassIds || []
              : (student: any) => [
                  ...(student.mathClassIds || []),
                  ...(student.englishClassIds || [])
                ];

        filtered = filtered.filter(student => {
          const ids = classIds(student as any);
          if (!ids || ids.length === 0) return false;
          return ids.some((id: string) => {
            const classGroup = schoolStore.currentSchoolStructure?.classGroups.find(
              (cls: any) => cls._id === id
            );
            return classGroup?.gradeLevel === gradeLevel;
          });
        });
      } else {
        // Fallback: grade only
        filtered = filtered.filter(student => {
          const classIds = [
            ...(student as any).mathClassIds || [],
            ...(student as any).englishClassIds || []
          ];
          if (!classIds || classIds.length === 0) return false;
          return classIds.some(id => {
            const classGroup = schoolStore.currentSchoolStructure?.classGroups.find(
              (cls: any) => cls._id === id
            );
            return classGroup?.gradeLevel === gradeLevel;
          });
        });
      }
    } else {
      // Filter by specific class group id (unique)
      const classId = gradeFilter.value;
      filtered = filtered.filter(student =>
        (student as any).mathClassIds?.includes(classId) ||
        (student as any).englishClassIds?.includes(classId)
      );
    }
  }

  // Apply sorting
  filtered.sort((a, b) => {
    let aValue = '';
    let bValue = '';

    switch (sortField.value) {
      case 'name':
        aValue = a.displayName;
        bValue = b.displayName;
        break;
      case 'email':
        aValue = a.email;
        bValue = b.email;
        break;
      case 'mathClass':
        aValue = a.mathClasses.join(', ');
        bValue = b.mathClasses.join(', ');
        break;
      case 'englishClass':
        aValue = a.englishClasses.join(', ');
        bValue = b.englishClasses.join(', ');
        break;
      case 'classes':
        aValue = [...a.mathClasses, ...a.englishClasses].join(', ');
        bValue = [...b.mathClasses, ...b.englishClasses].join(', ');
        break;
    }

    if (sortDirection.value === 'asc') {
      return aValue.localeCompare(bValue);
    } else {
      return bValue.localeCompare(aValue);
    }
  });

  return filtered;
});

// NEW: Paginated students - this is what should be displayed in the table
const paginatedStudents = computed(() => {
  return filteredStudents.value.slice(0, itemsPerPage.value);
});

// Pagination helpers
const startIndex = computed(() => 0);
const endIndex = computed(() => Math.min(itemsPerPage.value, filteredStudents.value.length));

const hasMore = computed(() => filteredStudents.value.length > itemsPerPage.value);
const nextBatchSize = computed(() => {
  const remaining = filteredStudents.value.length - itemsPerPage.value;
  return Math.min(50, remaining);
});

// Check what subjects are present in the data
const subjectsPresent = computed(() => {
  const structure = schoolStore.currentSchoolStructure;
  
  // If no structure or no subjectsAvailable, fall back to checking learner data
  if (!structure || !structure.subjectsAvailable) {
    // Fallback: check learner data
    const subjects = new Set<string>();
    
    learnerStore.schoolLearners?.forEach(learner => {
      learner.classes?.forEach(cls => {
        subjects.add(cls.subject.code);
      });
    });
    
    return {
      hasMaths: subjects.has('MATHS'),
      hasEnglish: subjects.has('ENGLISH'),
      bothPresent: subjects.has('MATHS') && subjects.has('ENGLISH')
    };
  }
  
  // Use subjectsAvailable from school structure
  const availableSubjectCodes = structure.subjectsAvailable.map(subject => subject.code);
  
  return {
    hasMaths: availableSubjectCodes.includes('MATHS'),
    hasEnglish: availableSubjectCodes.includes('ENGLISH'),
    bothPresent: availableSubjectCodes.includes('MATHS') && availableSubjectCodes.includes('ENGLISH')
  };
});

const classGroups = computed(() => schoolStore.currentSchoolStructure?.classGroups || []);
const subjects = computed(() => subjectStore.subjects || []);

const { gradeSubjectOptions: gradeFilterOptions } = useGradeSubjectFilterOptions(
  classGroups,
  subjects
);

/**
 * methods
 */
const handleSearchInput = (value: string | { name: string }) => {
  // Handle both string input and object selection from FormKit
  if (typeof value === 'string') {
    searchQuery.value = value;
  } else if (value && typeof value === 'object' && 'name' in value) {
    searchQuery.value = value.name;
  }
};

const getAllClassesForStudent = (student: StudentDisplay): string => {
  const allClasses = [...student.mathClasses, ...student.englishClasses];
  return allClasses.length > 0 ? allClasses.join(', ') : 'None Assigned';
};

const BulkAddUpdateStudents = () => {
  // Logic for bulk adding or updating students
  window.location.href = '/bulkaddeditstudentsnew';
};

const showStudentSummary = (userId: string) => {
  if (isV2Only.value) return; // block modal for V2-only
  bus.emit("show-student-modal", { userId: userId });
};

const addStudent = () => {
  // Logic to add a new student
  console.log('Add student clicked');
};

const sortBy = (field: string) => {
  if (sortField.value === field) {
    sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
  } else {
    sortField.value = field;
    sortDirection.value = 'asc';
  }
};

const togglePassword = async (studentId: string) => {
  // If we're hiding the password, just toggle visibility
  if (passwordVisibility.value[studentId]) {
    passwordVisibility.value[studentId] = false;
    return;
  }
  
  // If showing password and haven't fetched it yet
  if (!decryptedPasswords.value[studentId]) {
    // Set loading state
    decryptionLoading.value[studentId] = true;
    
    try {
      // Fetch decrypted password from server
      const decryptedPassword = await learnerStore.fetchDecryptedPassword(studentId);
      
      if (decryptedPassword) {
        decryptedPasswords.value[studentId] = decryptedPassword;
        passwordVisibility.value[studentId] = true;
      } else {
        showToast({
          text: 'Failed to decrypt password',
          type: 'error',
          icon: CheckCircleIcon,
        });
      }
    } catch (error) {
      console.error('Failed to decrypt password:', error);
      showToast({
        text: 'Failed to decrypt password',
        type: 'error',
        icon: CheckCircleIcon,
      });
    } finally {
      decryptionLoading.value[studentId] = false;
    }
  } else {
    // Password already fetched, just toggle visibility
    passwordVisibility.value[studentId] = true;
  }
};

/**
 * Resets the password state for a student after it has been updated.
 */
const handlePasswordReset = (studentId: string) => {
  // Delete the cached decrypted password for the student
  if (decryptedPasswords.value[studentId]) {
    delete decryptedPasswords.value[studentId];
  }
  // Ensure the password visibility is turned off
  if (passwordVisibility.value[studentId]) {
    passwordVisibility.value[studentId] = false;
  }
};

/**
 * Caches the password in the parent component when fetched by the child modal.
 */
const handlePasswordFetched = (password: string) => {
  if (selectedLearner.value) {
    decryptedPasswords.value[selectedLearner.value._id] = password;
  }
};

const loginAsStudent = async (
  student: Pick<Learner, "_id" | "firstName" | "lastName" | "email">
) => {
  void activityLogStore.logGenericActivityEvent({
    school: filterStore.selectedFilters.school || null,
    entityId: student._id,
    entityType: "user",
    actionType: "login",
    details: {
      note: `Impersonated student login - ${student.firstName || ""} ${student.lastName || ""}`.trim()
    },
  });

  // Construct the login URL with the student's ID. On a zero-rated free host
  // this resolves to free-app so the opened learner session stays zero-rated.
  const loginUrl = `${getLearnerAppUrl()}/auth/login?uid=${student._id}&pw=1`;
  
  // Open the learner app in a new tab
  window.open(loginUrl, '_blank');
};

const editStudent = (student: Learner) => {
  selectedLearner.value = student;
  showEditLearnerModal.value = true;
};

const openArchiveStudentModal = (student: Learner) => {
  showArchiveLearnerModal.value = true;
  selectedLearner.value = student;
};

const archiveStudent = async (studentId: string) => {
  try {
    await learnerStore.updateLearner([studentId], { status: 'archived' });
    showArchiveLearnerModal.value = false;
    showToast({
      text: `Successfully Archived ${selectedLearner.value?.firstName + ' ' + selectedLearner.value?.firstName}`,
      type: 'success',
      icon: CheckCircleIcon,
    });
    selectedLearner.value = null;
  } catch (error) {
    showToast({
      text: `Failed to archive ${selectedLearner.value?.firstName + ' ' + selectedLearner.value?.firstName}`,
      type: 'error',
      icon: CheckCircleIcon,
    });
  }
}

const showMoreStudents = () => {
  itemsPerPage.value += BATCH_SIZE;
  // Logic to load more students from your data source
};

const downloadClassPdf = async () => {
  const classGroup = getSelectedClassData();
  if (!classGroup?.classId || !Array.isArray(classGroup.students) || classGroup.students.length === 0) {
    showToast({
      text: "Please select a class to download.",
      type: 'error',
      icon: ExclamationCircleIcon,
    })
    return;
  }
  const schoolId = schoolStore.getSchoolStructure?._id;
  if (!schoolId) {
    showToast({
      text: "No school selected.",
      type: 'error',
      icon: ExclamationCircleIcon,
    })
    return;
  }
  loading.value = true;
  try {
    await learnerStore.fetchSchoolLearners(schoolId);
    const refreshedClassGroup = getSelectedClassData();
    if (!refreshedClassGroup?.classId || !Array.isArray(refreshedClassGroup.students) || refreshedClassGroup.students.length === 0) {
      showToast({
        text: "No students found for the selected class.",
        type: 'error',
        icon: ExclamationCircleIcon,
      })
      return;
    }
    generatePdf(refreshedClassGroup, true, isV2Only.value);
  } catch (error) {
    showToast({
      text: "There was an error refreshing student data.",
      type: 'error',
      icon: ExclamationCircleIcon,
    })
  } finally {
    loading.value = false;
  }
};

const openConfirmDownloadModal = (type: 'single' | 'all') => {
  downloadType.value = type;
  showConfirmDownloadModal.value = true;
};

const confirmDownload = async () => {
  const classData = getSelectedClassData();
  loading.value = true;
  showConfirmDownloadModal.value = false;
  const grade = (classData.gradeLevel === "all") ? undefined : classData.gradeLevel;
  const classId = classData.classId ? classData.classId : undefined;
  const schoolId = schoolStore.getSchoolStructure?._id;
  learnerStore.downloadSchoolPasswords(schoolId, grade, schoolStore.currentSchoolStructure?.name, classId)
    .then((response) => {
      loading.value = false;
      showToast({
        text: "Print logins downloaded successfully.",
        type: 'success',
        icon: CheckCircleIcon,
      })
    })
    .catch((error) => {
      showToast({
        text: "There was an error printing school logins.",
        type: 'error',
        icon: ExclamationCircleIcon,
      })
      loading.value = false;
    });
};

const handleLoginPasswordDownload = async () => {
  const classData = getSelectedClassData();
  if (classData.classId) {
    await downloadClassPdf();
    return;
  }
  if (gradeFilter.value.startsWith('grade-') || gradeFilter.value === "") {
    openConfirmDownloadModal('all');
  } else {
    if (classData.students.length > 100) {
      openConfirmDownloadModal('single');
      return;
    }
    //direct download, no confirm needed
    downloadType.value = 'all';
    confirmDownload();
  }
};

const getSelectedClassData = () => {
  const isGradeSelected = gradeFilter.value.startsWith('grade-');
  const selectedClass = isGradeSelected
    ? undefined
    : schoolStore.currentSchoolStructure?.classGroups.find(cls => cls._id === gradeFilter.value);

  const students = filteredStudents.value.map(student => {
    const studentData = learnerStore.schoolLearners.find(learner => learner._id === student._id);
    if (studentData.password && studentData.password.length > 0) {
      student.password = studentData.password;
    }
    return student; 
  });
  // determine grade selected
  let gradeSelected;
  if (gradeFilter.value === "") {
    gradeSelected = 'all';
  } else if (isGradeSelected) {
    const match = gradeFilter.value.match(/^grade-(\d+)(?:-(\w+))?$/);
    gradeSelected = match ? parseInt(match[1]) : 'all';
  } else {
    gradeSelected = selectedClass?.gradeLevel || 'all';
  }
  return {
    name: (!isGradeSelected) ? (selectedClass?.name || '') : 'All',
    gradeLevel: gradeSelected,
    schoolName: schoolStore.currentSchoolStructure?.name || 'School',
    subject: (selectedClass?.subject) ? subjectStore.getSubjectNameById(selectedClass.subject) : "",
    students: students,
    classId: selectedClass ? selectedClass._id : null,
  };
};

const confirmReassessment = async () => {
  reassessmentLoading.value = true;
  try {
    const learnerIds = filteredStudents.value.map(s => s._id);
    await learnerStore.triggerReassessment(learnerIds);
    showReassessmentConfirmModal.value = false;
    showToast({
      text: `Reassessment triggered for ${learnerIds.length} student(s).`,
      type: 'success',
      icon: CheckCircleIcon,
    });
  } catch (error) {
    showToast({
      text: "There was an error triggering reassessment.",
      type: 'error',
      icon: ExclamationCircleIcon,
    });
  } finally {
    reassessmentLoading.value = false;
  }
};

// To handle route changes while on the same component
watch(() => route.query.classId, (newClassId) => {
  if (newClassId) {
    // Find the class in the school structure by _id
    const classGroup = schoolStore.currentSchoolStructure?.classGroups.find(
      cls => cls._id === newClassId as string
    );
    
    if (classGroup) {
      // set the filter to the unique class id
      gradeFilter.value = classGroup._id;
    }
  } else {
    // Clear filter if no classId in query
    gradeFilter.value = '';
  }
});

// To clear the query param when user manually changes the filter
watch(gradeFilter, (newValue) => {
  // Only clear if the filter was changed by user interaction (not by route)
  if (route.query.classId && newValue !== '') {
    const classGroup = schoolStore.currentSchoolStructure?.classGroups.find(
      cls => cls._id === route.query.classId
    );
    
    // If the current filter doesn't match the query param class, clear the query
    if (!classGroup || classGroup._id !== newValue) {
      router.push({ path: '/studentsnew' });
    }
  }
});

onMounted(async () => {
  // Resolve the school and load its structure + learners fresh
  await loadStudents();

  // Check if classId is in query params
  const classId = route.query.classId as string;
  if (classId) {
    // Find the class in the school structure
    const classGroup = schoolStore.currentSchoolStructure?.classGroups.find(
      cls => cls._id === classId
    );
    
    if (classGroup) {
      // Set the grade filter to the class _id (unique)
      gradeFilter.value = classGroup._id;
    }
  }
});

/**
 * Bulk Upload Learners
 */
const isSchoolAdmin = computed(() => userStore.isSchoolAdmin);
const isInternalAdmin = computed(() => userStore.isInternalAdmin);
const isSchoolGroupAdmin = computed(() => userStore.isSchoolGroupAdmin);
const isClassGroupAdmin = computed(() => userStore.isClassGroupAdmin);
const canPerformGeneralAction = computed(
  () => isSchoolAdmin.value || isInternalAdmin.value || isSchoolGroupAdmin.value || isClassGroupAdmin.value
);

const showLearnersBulkUploadProgressModal = ref(false);
const showBulkUploadModal = ref(false);
const showPermissionDeniedModal = ref(false);
const showBulkUploadLearnersPreview = ref(false);
const learnersToUpload = ref<any>([]);

const ShowUploadOptions = () => {
  showBulkUploadLearnersPreview.value = false;
  showBulkUploadModal.value = true;
};

const handleGradeBulkUpload = () => {
  if (process.env.VUE_APP_FEATURE_FLAG_NEW_BULK_ADD_EDIT_VIEW == 'true') {
    router.push({ path: '/manage/bulk-add-edit-student' })
  } else {
    if (canPerformGeneralAction.value) {
      showBulkUploadModal.value = true;
    } else {
      showPermissionDeniedModal.value = true;
    }
  }
};

const receiveLearnersToUpload = (learners: any) => {
  learnersToUpload.value = JSON.parse(JSON.stringify(learners));
  showBulkUploadLearnersPreview.value = true;
};

const handleFinalUpload = (learners: any) => {
  showBulkUploadLearnersPreview.value = false;
  showBulkUploadModal.value = false;
  submitLearnersForUpload(learners);
};

const submitLearnersForUpload = async (learners: any) => {
  loading.value = true;
  try {
    await learnerStore.bulkCreateLearners(learners);
    showLearnersBulkUploadProgressModal.value = true;
    loading.value = false;
  } catch (error) {
    console.error(error);
    loading.value = false;
  }
};

const uploadInProgress = () => {
  showLearnersBulkUploadProgressModal.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_modal = _resolveComponent("modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_title, { pages: pages }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["text-gray-700 border-gray-300", { 'opacity-50 cursor-not-allowed': paginatedStudents.value.length === 0 }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleLoginPasswordDownload())),
          disabled: paginatedStudents.value.length === 0
        }, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_spinner_loader, { color: 'text-[#155EEF]' })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-printer',
              title: 'rl home',
              "aria-hidden": "true"
            })
          ]),
          _createTextVNode(" Print Logins ")
        ], 10, _hoisted_4),
        _createElementVNode("button", _hoisted_7, [
          _createVNode(ExportLearnersButtonComponent)
        ]),
        showBulkAddButton
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "text-gray-700 border-gray-300",
              onClick: handleGradeBulkUpload
            }, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-circle',
                  title: 'rl circle',
                  "aria-hidden": "true"
                })
              ]),
              _createTextVNode(" Bulk Add/Update Students ")
            ]))
          : _createCommentVNode("", true),
        (isInternalAdmin.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: _normalizeClass(["text-gray-700 border-gray-300", { 'opacity-50 cursor-not-allowed': filteredStudents.value.length === 0 || reassessmentLoading.value }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showReassessmentConfirmModal.value = true)),
              disabled: filteredStudents.value.length === 0 || reassessmentLoading.value
            }, [
              (reassessmentLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_spinner_loader, { color: 'text-[#155EEF]' })
                  ]))
                : (_openBlock(), _createBlock(_unref(ArrowPathIcon), {
                    key: 1,
                    class: "h-5 w-5"
                  })),
              _createTextVNode(" Trigger Reassessment ")
            ], 10, _hoisted_9))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showAddLearnerModal.value = true)),
          class: "text-white border-blue-600 bg-blue-600 hover:bg-blue-500"
        }, [
          _createVNode(_unref(PlusIcon), { class: "h-5 w-5" }),
          _createTextVNode(" Add Student ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      true
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_FormKit, {
                type: "treeSelect",
                name: "gradeFilter",
                modelValue: gradeFilter.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((gradeFilter).value = $event)),
                selectOptions: _unref(gradeFilterOptions),
                classes: {
            outer: 'w-full'
          }
              }, null, 8, ["modelValue", "selectOptions"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_FormKit, {
          type: "text",
          name: "selectedLearner",
          placeholder: 'Search',
          onInput: _cache[4] || (_cache[4] = ($event: any) => (handleSearchInput($event as any))),
          classes: {
          input: 'pl-10'
        },
          "prefix-icon": "search"
        })
      ])
    ]),
    (pageLoading.value || _unref(learnerStore).loader.learner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_spinner_loader, { color: 'text-blue-600' }),
            _hoisted_18
          ])
        ]))
      : (loadError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_unref(ExclamationCircleIcon), { class: "h-12 w-12 mx-auto text-amber-400 mb-4" }),
            _hoisted_20,
            _hoisted_21,
            _hoisted_22,
            _createElementVNode("button", {
              class: "text-blue-600 hover:text-blue-500 font-semibold",
              onClick: loadStudents
            }, " Reload students ")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("table", _hoisted_25, [
                _createElementVNode("thead", _hoisted_26, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      class: "w-48 px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (sortBy('name')))
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode(_unref(ChevronUpDownIcon), { class: "h-4 w-4" })
                      ])
                    ]),
                    _createElementVNode("th", {
                      class: "w-48 px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (sortBy('email')))
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createVNode(_unref(ChevronUpDownIcon), { class: "h-4 w-4" })
                      ])
                    ]),
                    _hoisted_31,
                    (subjectsPresent.value.bothPresent)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          class: "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (sortBy('mathClass')))
                        }, [
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createVNode(_unref(ChevronUpDownIcon), { class: "h-4 w-4" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (subjectsPresent.value.bothPresent)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 1,
                          class: "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (sortBy('englishClass')))
                        }, [
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createVNode(_unref(ChevronUpDownIcon), { class: "h-4 w-4" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!subjectsPresent.value.bothPresent && (subjectsPresent.value.hasMaths || subjectsPresent.value.hasEnglish))
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 2,
                          class: "px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider cursor-pointer hover:bg-gray-100",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (sortBy('classes')))
                        }, [
                          _createElementVNode("div", _hoisted_36, [
                            _hoisted_37,
                            _createVNode(_unref(ChevronUpDownIcon), { class: "h-4 w-4" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_38
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedStudents.value, (student) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: student._id,
                      class: "hover:bg-gray-50"
                    }, [
                      _createElementVNode("td", _hoisted_40, [
                        (isV2Only.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(student.displayName), 1))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "text-sm font-medium text-blue-600 hover:text-blue-500 truncate max-w-[12rem]",
                              onClick: ($event: any) => (showStudentSummary(student._id))
                            }, _toDisplayString(student.displayName), 9, _hoisted_42))
                      ]),
                      _createElementVNode("td", _hoisted_43, [
                        _withDirectives(_createElementVNode("div", _hoisted_44, null, 512), [
                          [
                            _directive_tooltip,
                            student.email,
                            "top",
                            { tooltip: true }
                          ]
                        ]),
                        _createElementVNode("div", _hoisted_45, _toDisplayString(student.email), 1)
                      ]),
                      _createElementVNode("td", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, [
                            (decryptionLoading.value[student._id])
                              ? (_openBlock(), _createElementBlock("span", _hoisted_49, " Decrypting... "))
                              : (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(student.showPassword && student.password ? student.password : '******'), 1))
                          ]),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (togglePassword(student._id)),
                            class: "text-gray-400 hover:text-gray-600",
                            disabled: decryptionLoading.value[student._id]
                          }, [
                            (decryptionLoading.value[student._id])
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_52, _hoisted_55))
                              : (!student.showPassword)
                                ? (_openBlock(), _createBlock(_unref(EyeIcon), {
                                    key: 1,
                                    class: "h-4 w-4"
                                  }))
                                : (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                                    key: 2,
                                    class: "h-4 w-4"
                                  }))
                          ], 8, _hoisted_51)
                        ])
                      ]),
                      (subjectsPresent.value.bothPresent)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, _toDisplayString(student.mathClasses.length > 0 ? student.mathClasses.join(', ') : 'None assigned'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (subjectsPresent.value.bothPresent)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, _toDisplayString(student.englishClasses.length > 0 ? student.englishClasses.join(', ') : 'None Assigned'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (!subjectsPresent.value.bothPresent && (subjectsPresent.value.hasMaths || subjectsPresent.value.hasEnglish))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, _toDisplayString(getAllClassesForStudent(student)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (loginAsStudent(student)),
                            class: "text-blue-600 hover:text-blue-500"
                          }, " Login ", 8, _hoisted_64),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (editStudent(student)),
                            class: "text-blue-600 hover:text-blue-500"
                          }, " Edit ", 8, _hoisted_65),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (openArchiveStudentModal(student)),
                            class: "text-red-600 hover:text-red-500"
                          }, " Archive ", 8, _hoisted_66)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])),
    (!pageLoading.value && !_unref(learnerStore).loader.learner && !loadError.value && paginatedStudents.value.length === 0 && filteredStudents.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
          (isSearchEmpty.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createVNode(_unref(MagnifyingGlassIcon), { class: "h-12 w-12 mx-auto text-gray-400" })
                ]),
                _hoisted_70,
                _createElementVNode("p", _hoisted_71, " Your search \"" + _toDisplayString(searchQuery.value) + "\" did not match any ", 1),
                _hoisted_72
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createVNode(_unref(UserIcon), { class: "h-12 w-12 mx-auto text-gray-400" })
                ]),
                _hoisted_75,
                _hoisted_76,
                _hoisted_77
              ]))
        ]))
      : _createCommentVNode("", true),
    (!pageLoading.value && !_unref(learnerStore).loader.learner && !loadError.value && filteredStudents.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
          _createElementVNode("div", null, " Showing " + _toDisplayString(startIndex.value + 1) + "-" + _toDisplayString(endIndex.value) + " of " + _toDisplayString(filteredStudents.value.length) + " students ", 1),
          (hasMore.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "text-blue-600 hover:text-blue-500",
                onClick: showMoreStudents
              }, " Show " + _toDisplayString(BATCH_SIZE) + " More "))
            : _createCommentVNode("", true)
        ]))
      : (!pageLoading.value && !_unref(learnerStore).loader.learner && !loadError.value && !isSearchEmpty.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
            _createElementVNode("div", null, " Showing 0-0 of " + _toDisplayString(filteredStudents.value.length) + " students ", 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-2xl',
      open: showAddLearnerModal.value,
      onLocalModalOpen: _cache[11] || (_cache[11] = ($event: any) => (showAddLearnerModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(AddLearnerModalComponent, {
          onCloseModal: _cache[10] || (_cache[10] = ($event: any) => (showAddLearnerModal.value = false))
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-2xl',
      open: showEditLearnerModal.value,
      onLocalModalOpen: _cache[13] || (_cache[13] = ($event: any) => (showEditLearnerModal.value = $event))
    }, {
      default: _withCtx(() => [
        (selectedLearner.value != null)
          ? (_openBlock(), _createBlock(EditLearnerModalComponent, {
              key: 0,
              studentId: selectedLearner.value?._id,
              onPasswordUpdated: handlePasswordReset,
              onPasswordFetched: handlePasswordFetched,
              onCloseModal: _cache[12] || (_cache[12] = ($event: any) => (showEditLearnerModal.value = false)),
              decryptedPassword: decryptedPasswords.value[selectedLearner.value._id]
            }, null, 8, ["studentId", "decryptedPassword"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-sm',
      open: showArchiveLearnerModal.value,
      onLocalModalOpen: _cache[16] || (_cache[16] = ($event: any) => (showArchiveLearnerModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-delete',
              title: 'rl delete',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("h2", _hoisted_82, " Archive " + _toDisplayString(selectedLearner.value?.firstName ?? '') + " " + _toDisplayString(selectedLearner.value?.lastName ?? '') + "? ", 1),
          _hoisted_83,
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("button", {
              type: "button",
              disabled: _unref(learnerStore).loader.learner,
              onClick: _cache[14] || (_cache[14] = ($event: any) => (selectedLearner.value && archiveStudent(selectedLearner.value._id))),
              class: "w-full font-semibold bg-red-600 rounded-lg py-2 px-6 text-white flex items-center justify-center gap-2"
            }, [
              _hoisted_86,
              (_unref(learnerStore).loader.learner)
                ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                    _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_85),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (showArchiveLearnerModal.value = false)),
              class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 w-full"
            }, " Cancel ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl',
      open: showConfirmDownloadModal.value,
      onLocalModalOpen: _cache[18] || (_cache[18] = ($event: any) => (showConfirmDownloadModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-download',
              title: 'rl download',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("h2", _hoisted_90, _toDisplayString(_ctx.$t("students_view.print_passwords.modal_header")), 1),
          (downloadType.value === 'single')
            ? (_openBlock(), _createElementBlock("p", _hoisted_91, [
                _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.$t("students_view.print_passwords.modal_description_single_intro")), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("students_view.print_passwords.modal_description_single")) + " ", 1),
                _hoisted_93,
                _hoisted_94,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("students_view.print_passwords.modal_proceed_text")), 1)
              ]))
            : _createCommentVNode("", true),
          (downloadType.value === 'all')
            ? (_openBlock(), _createElementBlock("p", _hoisted_95, [
                _createTextVNode(_toDisplayString(_ctx.$t("students_view.print_passwords.modal_description_multiple_intro")) + " ", 1),
                _createElementVNode("span", _hoisted_96, _toDisplayString(_ctx.$t("students_view.print_passwords.modal_description_multiple")), 1),
                _hoisted_97,
                _hoisted_98,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("students_view.print_passwords.modal_proceed_text")), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("button", {
              class: "mr-2 text-gray-700 border border-gray-300 text-sm font-semibold px-3 py-2.5 bg-white rounded-lg items-center flex-wrap w-full",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (showConfirmDownloadModal.value = false))
            }, _toDisplayString(_ctx.$t("students_view.print_passwords.modal_cancel_btn")), 1),
            _createElementVNode("button", {
              class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-3 py-2.5 rounded-lg items-center flex-wrap disabled:opacity-50 w-full",
              onClick: confirmDownload
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                    _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("students_view.print_passwords.modal_proceed_btn")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl',
      open: showReassessmentConfirmModal.value,
      onLocalModalOpen: _cache[20] || (_cache[20] = ($event: any) => (showReassessmentConfirmModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_101, [
          _createElementVNode("div", _hoisted_102, [
            _createVNode(_unref(ArrowPathIcon), { class: "h-8 w-8 text-blue-600" })
          ]),
          _hoisted_103,
          _createElementVNode("p", _hoisted_104, [
            _createTextVNode(" This will trigger a reassessment for "),
            _createElementVNode("span", _hoisted_105, _toDisplayString(filteredStudents.value.length) + " student(s)", 1),
            (getSelectedClassData().name && getSelectedClassData().name !== 'All')
              ? (_openBlock(), _createElementBlock("span", _hoisted_106, [
                  _createTextVNode(" in "),
                  _createElementVNode("span", _hoisted_107, _toDisplayString(getSelectedClassData().name), 1)
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(". "),
            _hoisted_108,
            _hoisted_109,
            _createTextVNode(" The next time these learners log in, they will be taken to their thread assessment. ")
          ]),
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("button", {
              class: "mr-2 text-gray-700 border border-gray-300 text-sm font-semibold px-3 py-2.5 bg-white rounded-lg items-center flex-wrap w-full",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (showReassessmentConfirmModal.value = false))
            }, " Cancel "),
            _createElementVNode("button", {
              class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-3 py-2.5 rounded-lg items-center flex-wrap disabled:opacity-50 w-full",
              onClick: confirmReassessment,
              disabled: reassessmentLoading.value
            }, [
              (reassessmentLoading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                    _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(" Confirm ")
            ], 8, _hoisted_111)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-sm',
      open: showPermissionDeniedModal.value,
      onLocalModalOpen: _cache[22] || (_cache[22] = ($event: any) => (showPermissionDeniedModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_113, [
          _createElementVNode("h2", _hoisted_114, _toDisplayString(_ctx.$t("modals.teacher_class_permission.title")), 1),
          _createElementVNode("p", _hoisted_115, _toDisplayString(_ctx.$t("modals.teacher_class_permission.description")), 1),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (showPermissionDeniedModal.value = false)),
            class: "w-full rounded-md bg-white px-2.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          }, _toDisplayString(_ctx.$t("modals.teacher_class_permission.btns.ok")), 1)
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    (showBulkUploadModal.value)
      ? (_openBlock(), _createBlock(BulkUploadLearners, {
          key: 6,
          uploadType: 'grade',
          classId: 'classId',
          className: 'className',
          grade: _unref(filterStore).selectedFilters.gradeLevel,
          onLocalModalOpen: _cache[23] || (_cache[23] = ($event: any) => (showBulkUploadModal.value = false)),
          onResetModalState: _cache[24] || (_cache[24] = ($event: any) => (showBulkUploadModal.value = false)),
          onTransmitLearnersToUpload: receiveLearnersToUpload
        }, null, 8, ["grade"]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      showCloseButton: false,
      widthClass: 'max-w-5xl',
      open: showBulkUploadLearnersPreview.value,
      onLocalModalOpen: _cache[27] || (_cache[27] = ($event: any) => (showBulkUploadLearnersPreview.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_116, [
          _createVNode(PreviewBulkUploadComponent, {
            uploadType: 'grade',
            grade: _unref(filterStore).selectedFilters.gradeLevel,
            subject: _unref(filterStore).selectedFilters.subject,
            learnersToUpload: learnersToUpload.value,
            onTransmitFinalLearners: handleFinalUpload,
            onCancelPreview: _cache[25] || (_cache[25] = ($event: any) => {showBulkUploadModal.value = false; showBulkUploadLearnersPreview.value = false;}),
            onResetState: _cache[26] || (_cache[26] = ($event: any) => (showBulkUploadModal.value = false)),
            onPreviousStep: ShowUploadOptions
          }, null, 8, ["grade", "subject", "learnersToUpload"])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg',
      open: showLearnersBulkUploadProgressModal.value,
      onLocalModalOpen: _cache[28] || (_cache[28] = ($event: any) => (showLearnersBulkUploadProgressModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_117, [
          _createElementVNode("div", _hoisted_118, [
            _createElementVNode("div", _hoisted_119, [
              _createElementVNode("div", {
                class: "absolute top-6 right-4 cursor-pointer",
                onClick: uploadInProgress
              }, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-large-close',
                  title: 'rl large close',
                  "aria-hidden": "true"
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-green-tick',
                  title: 'rl green tick',
                  "aria-hidden": "true"
                })
              ]),
              _createElementVNode("h1", _hoisted_120, _toDisplayString(_ctx.$t("bulk_learner_upload_component.modal.header")), 1),
              _createElementVNode("p", {
                class: "font-normal text-sm text-gray-600 text-center mt-2",
                innerHTML: _ctx.$t('bulk_learner_upload_component.modal.sub_header')
            
              }, null, 8, _hoisted_121),
              _createElementVNode("p", _hoisted_122, _toDisplayString(_ctx.$t("bulk_learner_upload_component.modal.important_info")), 1),
              _createElementVNode("button", {
                onClick: uploadInProgress,
                class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 mt-8 w-full"
              }, _toDisplayString(_ctx.$t("students_view.done")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})